<template>
<div class="documents-upload">
  <b-form-group :label="'Documento' + (multiple ? 's' : '')" :description="'Selecione um '+ (multiple ? 'ou mais arquivos' : 'arquivo') +' no formato PDF, JPG, JPEG, KMZ ou DOC, com no máximo 32 MB.'" v-show="!isLoading">
    <div class="row-fluid" v-if="!isLoading">
      <br>
      <div v-if="Array.isArray(form[field]) && form[field].length > 0">
        <div class="col-sm-12" v-for="(doc, index) in form[field]" :key="index">
          <a :href="(baseUrl + doc)" target="_blank">
            <strong>{{ doc | filename }}</strong>
          </a>
          <div class="text-right">
            <a class="btn-sm" @click="deleteDocument(index)"><i class="fa fa-trash"></i></a>
          </div>
        </div>
      </div>
      <div v-if="!Array.isArray(form[field]) && form[field]">
        <div class="col-sm-12">
          <a :href="(baseUrl + form[field])" target="_blank">{{ form[field] | filename }}</a>
          <div class="text-right">
            <a class="btn-sm" @click="deleteDocument()"><i class="fa fa-trash"></i></a>
          </div>
        </div>
      </div>
    </div>
    <loading :loading="isLoading" msg="Enviando documento" />
    <span class="btn btn-primary btn-sm btn-file" @click="selectFile()">
      <span class="fileinput-new"><i class="fa fa-upload"></i> Anexar documento{{ multiple ? 's' : ''}} </span>
      <b-form-file ref="files" id="files" :multiple="multiple" accept="application/msword, application/vnd.google-earth.kml+xml, image/*, application/pdf" v-on:change="uploadDocuments"></b-form-file>
    </span>
    <span class="text-danger" v-show="error">{{ error }}</span>
  </b-form-group>
</div>
</template>

<script>
import axios from 'axios'
import Loading from './Loading'

export default {

  name: 'documents-upload',
  props: ['form', 'multiple', 'field', 'url', 'cb'],
  methods: {
    uploadDocuments(e) {
      this.error = false
      this.isLoading = true
      let files = e.target.files || e.dataTransfer.files;
      for (var i = 0; i < files.length; i++) {
        var file = files[i]
        var formData = new FormData();
        formData.append('document', file, file.name);
        axios.post(this.url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          if (this.multiple) {
            this.form[this.field].push(response.data)
          } else {
            this.form[this.field] = response.data
          }
          if (this.cb) {
            this.cb(this.form)
          }
          this.isLoading = false
        }).catch((error) => {
          this.isLoading = false
          this.showError(error)
        });
      }
    },
    deleteDocument(index) {
      if (this.multiple) {
        this.$delete(this.form[this.field], index)
      } else {
        this.form[this.field] = null
      }
      if (this.cb) {
        this.cb(this.form)
      }
    },
    fileName(doc) {
      if (doc) {
        var doc_url = doc.split('/')
        return doc_url[doc_url.length - 1]
      }
    },
    selectFile() {
      document.getElementById('files').click()
    }

  },
  components: {
    'loading': Loading
  }

};
</script>

<style lang="sass">
.custom-file-label, .custom-file.b-form-file
  display: none

  </style>
